// Central test IDs for QA automation. Each feature exports its own object.
export const NAV = {
  brand: "nav-brand",
  home: "nav-home",
  about: "nav-about",
  chess: "nav-chess-leadership",
  news: "nav-news",
  videos: "nav-videos",
  companies: "nav-companies",
  thought: "nav-thought-leadership",
  mediaKit: "nav-media-kit",
  gallery: "nav-gallery",
  contact: "nav-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HOME = {
  hero: "home-hero",
  ctaBio: "home-cta-bio",
  ctaMediaKit: "home-cta-media-kit",
  ctaNews: "home-cta-news",
  ctaCompanies: "home-cta-companies",
  ctaSpeaking: "home-cta-speaking",
  pillars: "home-pillars",
  pillar: (i) => `home-pillar-${i}`,
  featuredIn: "home-featured-in",
  featuredChess: "home-featured-chess",
  featuredCompanies: "home-featured-companies",
  latestNews: "home-latest-news",
  latestVideos: "home-latest-videos",
};

export const SPEAKING = {
  page: "speaking-page",
  topic: (i) => `speaking-topic-${i}`,
  bookCta: "speaking-book-cta",
};

export const MEDIA_KIT = {
  page: "media-kit-page",
  quote: (i) => `mk-quote-${i}`,
  topic: (i) => `mk-topic-${i}`,
};

export const NEWS = {
  list: "news-list",
  search: "news-search-input",
  filter: "news-category-filter",
  item: (id) => `news-item-${id}`,
};

export const VIDEOS = {
  list: "videos-list",
  filter: "videos-category-filter",
  item: (id) => `video-item-${id}`,
};

export const COMPANIES = {
  list: "companies-list",
  item: (slug) => `company-item-${slug}`,
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  org: "contact-org",
  type: "contact-type",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  dashboard: "admin-dashboard",
  tabNews: "admin-tab-news",
  tabVideos: "admin-tab-videos",
  tabArticles: "admin-tab-articles",
  tabCompanies: "admin-tab-companies",
  tabLeads: "admin-tab-leads",
  tabGallery: "admin-tab-gallery",
  logout: "admin-logout",
};
